import React from 'react'
import CognitoUserDetail from './abstract/CognitoUserDetail'
import Config from '../../../Config'
import Loading from '../../../common/component/Loading'

class AdminUserDetail extends CognitoUserDetail {
  constructor (props) {
    super(props)
    this.state = {userDetail: '', temporaryPassword: ''}
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRoleName = '事務局管理者'
    this.userRoleUrl = 'admin_user'
    this.userRole = 'admin'
  }
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const temporaryPassword = queryParams.get('temporaryPassword');
    
    if (temporaryPassword) {
      this.setState({ temporaryPassword });
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const userDetail = this.renderUserDetail(this.userRoleName + '情報', '氏名', this.state.userDetail, this.state.temporaryPassword)
    const disableButton = (<li key='disable' className='kw-btn-area'><button id='suspend-button' rel='tooltip' title='一時無効' data-placement='bottom' className='kw-btn-info' onClick={(e) => this.onPageMenuClicked('disable', e)} ><i className='icon-eye-close icon-large' /><span>一時<br />無効</span></button></li>)
    const enableButton = (<li key='enable' className='kw-btn-area'><button id='resurrection-button' rel='tooltip' title='復活' data-placement='bottom' className='kw-btn-info' onClick={(e) => this.onPageMenuClicked('enable', e)} ><i className='icon-heart-empty icon-large' /><span>復活</span></button></li>)
    const disableOrEnable = this.state.userDetail.enabled ? disableButton : enableButton
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>{this.userRoleName}情報 - 詳細<br /><small>こちらで{this.userRoleName}の情報を参照できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back', e)} ><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                  <li className='kw-btn-area'><button id='edit-button' rel='tooltip' title='編集' data-placement='bottom' className='kw-btn-success' onClick={(e) => this.onPageMenuClicked('edit', e)} ><i className='icon-edit icon-large' /><span>編集</span></button></li>
                  <li key='ban' className='kw-btn-area'><button id='delete-button' rel='tooltip' title='削除' data-placement='bottom' className='kw-btn-danger' onClick={(e) => this.onPageMenuClicked('ban', e)} ><i className='icon-remove icon-large' /><span>削除</span></button></li>
                  {disableOrEnable}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container form-horizontal'>
          <div className='row'>
            {userDetail}
          </div>
        </section>
      </div>
    )
  }
}

export default AdminUserDetail



// WEBPACK FOOTER //
// ./src/admin/pages/secure/AdminUserDetail.js